declare namespace $ {

	type $mol_paragraph__title_bog_bzrl_app_rent_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $bog_bzrl_app_filter__district_bog_bzrl_app_rent_2 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['district'] >
		,
		ReturnType< $bog_bzrl_app_filter['district'] >
	>
	type $bog_bzrl_app_filter__rooms_bog_bzrl_app_rent_3 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['rooms'] >
		,
		ReturnType< $bog_bzrl_app_filter['rooms'] >
	>
	type $bog_bzrl_app_filter__price_from_bog_bzrl_app_rent_4 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['price_from'] >
		,
		ReturnType< $bog_bzrl_app_filter['price_from'] >
	>
	type $bog_bzrl_app_filter__search_bog_bzrl_app_rent_5 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['search'] >
		,
		ReturnType< $bog_bzrl_app_filter['search'] >
	>
	type $bog_bzrl_app_card__district_bog_bzrl_app_rent_6 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['apartment_district'] >
		,
		ReturnType< $bog_bzrl_app_card['district'] >
	>
	type $bog_bzrl_app_card__photo_bog_bzrl_app_rent_7 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['apartment_photo'] >
		,
		ReturnType< $bog_bzrl_app_card['photo'] >
	>
	type $bog_bzrl_app_card__area_bog_bzrl_app_rent_8 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['apartment_area'] >
		,
		ReturnType< $bog_bzrl_app_card['area'] >
	>
	type $bog_bzrl_app_card__floor_bog_bzrl_app_rent_9 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['apartment_floor'] >
		,
		ReturnType< $bog_bzrl_app_card['floor'] >
	>
	type $bog_bzrl_app_card__price_bog_bzrl_app_rent_10 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['apartment_price'] >
		,
		ReturnType< $bog_bzrl_app_card['price'] >
	>
	type $mol_view__attr_bog_bzrl_app_rent_11 = $mol_type_enforce<
		({ 
			'id': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_bzrl_app_rent_12 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['apartment_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_bzrl_app_hero_promo__action_bog_bzrl_app_rent_13 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_rent['promo_action'] >
		,
		ReturnType< $bog_bzrl_app_hero_promo['action'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_rent_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_bzrl_app_rent_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_bzrl_app_rent_16 = $mol_type_enforce<
		({ 
			'id': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_bzrl_app_rent_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_bzrl_app_rent_18 = $mol_type_enforce<
		({ 
			'id': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_bzrl_app_rent_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_rent_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_bzrl_app_rent_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_bzrl_app_rent_22 = $mol_type_enforce<
		({ 
			'id': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_bzrl_app_rent_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_bzrl_app_hero_team__attr_bog_bzrl_app_rent_24 = $mol_type_enforce<
		({ 
			'id': string,
		}) 
		,
		ReturnType< $bog_bzrl_app_hero_team['attr'] >
	>
	type $bog_bzrl_app_hero_team__photo_bog_bzrl_app_rent_25 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_bzrl_app_hero_team['photo'] >
	>
	type $bog_bzrl_app_footer__attr_bog_bzrl_app_rent_26 = $mol_type_enforce<
		({ 
			'id': string,
		}) 
		,
		ReturnType< $bog_bzrl_app_footer['attr'] >
	>
	export class $bog_bzrl_app_rent extends $mol_view {
		Title_section( ): $mol_paragraph
		district( next?: string ): string
		rooms( next?: string ): string
		price_from( next?: string ): string
		search( next?: any ): any
		Filter( ): $bog_bzrl_app_filter
		apartment_district( id: any): string
		apartment_photo( id: any): string
		apartment_area( id: any): string
		apartment_floor( id: any): string
		apartment_price( id: any): string
		Apartment( id: any): $bog_bzrl_app_card
		apartment_rows( ): readonly($mol_view)[]
		Apartments( ): $mol_view
		promo_action( next?: any ): any
		Promo( ): $bog_bzrl_app_hero_promo
		How_title( ): $mol_paragraph
		Step_match( ): $bog_bzrl_app_step_match
		Step_request( ): $bog_bzrl_app_step_request
		Step_pay( ): $bog_bzrl_app_step_pay
		Steps( ): $mol_view
		How_it_works( ): $mol_view
		Privacy_slider( ): $bog_bzrl_app_slider
		Privacy_content( ): $bog_bzrl_app_hero_privacy
		Privacy( ): $mol_view
		Benefits_title( ): $mol_paragraph
		Benefit_owners( ): $bog_bzrl_app_benefit_owners
		Benefit_verified( ): $bog_bzrl_app_benefit_verified
		Benefit_secure( ): $bog_bzrl_app_benefit_secure
		Benefits_list( ): $mol_view
		Benefits( ): $mol_view
		Team( ): $bog_bzrl_app_hero_team
		Footer( ): $bog_bzrl_app_footer
		apartments( ): readonly(any)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=rent.view.tree.d.ts.map